import React from 'react';
import './RedirectToPage.css';
import Button from '../Button/Button';
import RedirectToPage2 from './RedirectToPage2';

const RedirectToPage = ({ link, title, image, details, ButtonText }) => {
  // Check if the image prop exists and is a valid string
  if (!image || image.trim() === '') {
    return <RedirectToPage2 link={link} title={title} details={details} ButtonText={ButtonText} />;
  }

  return (
    <div className="RedirectToPage-container">
      <div className="RedirectToPage-left">
        <img src={image} alt={title} className="RedirectToPage-image" />
      </div>
      <div className="RedirectToPage-right">
        <h2 className="RedirectToPage-title">{title}</h2>
        <p className="RedirectToPage-details">{details}</p>
        <Button to={link}>{ButtonText}</Button>
      </div>
    </div>
  );
};

export default RedirectToPage;
